<template>
  <div class="" id="dg__cascader" @click="() => toggleDropDownVisible(true)"
    v-clickoutside="() => toggleDropDownVisible(false)">
    <div class="tags" ref="cascaderTags">
      <div v-for="(v, index) in this.texts" :key="index" class="items-center item">
        <p class="max-w-170"> {{ v.text }}</p>
        <i class="el-tag__close el-icon-close t-[14] cursor-pointer ml-[4]"
          @click.stop="handlerClose(v.qualCode, index)"></i>
      </div>
      <div>
        <!-- <input @focus="handleFocus" ref="input" @input="handelInput" v-model="inputValue" type="text" class="dg_input" placeholder="请输入" /> -->
        <el-input @focus="handleFocus" ref="input" @input="handelInput" v-model="inputValue" type="text"
          class="dg_input" placeholder="请搜索选择证书资质"></el-input>
      </div>
    </div>
    <div class="dg-scrollbar__view dg-cascader-menu__list" :style="{ top: top }" v-show="this.dropDownVisible"
      @click="() => toggleDropDownVisible(true)">
      <ul class="leve1">
        <li @click="handleCheckChange(index)" v-for="(v, index) in this.menus" :key="index" class="dg-cascader-node flex"
          v-show="v.hide || v.hide != false" :class="{ active: v.select, click: v.click }">
          <p class="max-w-300">{{ v.qualName }}</p>
          <i v-if="v.select" class="dg-cascader-node__postfix t-[14] icon">&#xe62f;</i>
          <i v-else class="dg-cascader-node__postfix t-[12] icon">&#xe646;</i>
        </li>
      </ul>
      <ul class="leve2" v-if="ranks.length">
        <li @click="handleCheckSelect(index)" v-for="(v, index) in ranks" :key="index" class="dg-cascader-node"
          :class="{ active: v.select }">
          <span>{{ v.rankName }}</span>
          <i v-if="v.select" class="dg-cascader-node__postfix t-[12] icon">&#xe62f;</i>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import Clickoutside from "@/assets/js/clickoutside";



export default {
  name: "dg-cascader",
  inject: ["elForm", "elFormItem"],
  directives: { Clickoutside },
  props: {
    value: Array,
    options: Array,

    props: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      index1: 0,
      top: "38px",
      inputValue: "",
      dropDownVisible: false,
      texts: [],
      menus: [],
      internalValue: []
    };
  },
  computed: {
    ranks() {
      if (this.menus[this.index1]) {
        return this.menus[this.index1].ranks;
      }
      return [];
    }
  },
  watch: {
    options: {
      handler(val) {
        if (val) {
          this.menus=[]
          val.forEach(el => {
            this.menus.push(el);
          });
        }
      },
      immediate: true
    },

    value: {
      handler(val) {
        if (val) {
          this.internalValue = val;
          this.initStore();
        }
      },
      immediate: true
    },
    inputValue: {
      handler(val) {
        if (val) {
          this.handelInput();
        }
      },
      immediate: true
    }

  },

  methods: {
    handleCheckChange(index) {
      this.index1 = index;
      this.menus.forEach((el, index) => {
        this.menus[index].click = false;
      });
      this.menus[index].click = true;
    },
    handleCheckSelect(index) {
      this.inputValue = "";
      if (this.menus[this.index1].ranks[index].select) {
        this.menus[this.index1].select = false;
        this.menus[this.index1].ranks[index].select = false;
        this.$forceUpdate();
        this.getValue();
        this.$nextTick(this.setTop);
        if (this.elFormItem && this.elFormItem.prop) {
              this.elForm.clearValidate(this.elFormItem.prop);
            }
        return;
      }

      this.menus[this.index1].select = true;
      this.menus[this.index1].ranks.forEach((el, index) => {
        if (this.menus[this.index1].ranks[index].select) {
          this.menus[this.index1].ranks[index].select = false;
        }
      });
      this.menus[this.index1].ranks[index].select = !this.menus[this.index1]
        .ranks[index].select;
      this.$forceUpdate();
      this.getValue();
      this.$nextTick(this.setTop);
      if (this.elFormItem && this.elFormItem.prop) {
              this.elForm.clearValidate(this.elFormItem.prop);
            }
    },
    handlerClose(v, index) {
      this.internalValue.splice(index, 1);
      this.clearValue();
      this.setValue(this.internalValue);
      this.$nextTick(this.setTop);
    },
    getValue() {
      this.internalValue = [];
      this.texts = [];
      this.menus.forEach(el => {
        el.ranks.forEach(item => {
          if (item.select) {
            this.internalValue.push([el.id, item.id]);
            this.texts.push({
              text: `${el.qualName}/${item.rankName}`,
              code: [item.id, item.rankValue].join("-")
            });
            this.$emit("input", this.internalValue);
            this.$emit("update", this.internalValue);
          }
        });
      });
    },
    clearValue() {
      this.menus.forEach((el, index) => {
        el.ranks.forEach((item, index2) => {
          this.menus[index].select = false;
          this.menus[index].ranks[index2].select = false;
        });
      });
    },
    setValue(val) {
      this.texts = [];
      val.forEach(elval => {
        let code = elval.join("-");
        this.menus.forEach((el, index1) => {
          el.ranks.forEach((item, index2) => {
            if (code == [el.id, item.id].join("-")) {
              this.texts.push({
                text: `${el.qualName}/${item.rankName}`,
                code: [item.id, item.rankValue].join("-")
              });
              this.menus[index1].select = true;
              this.menus[index1].ranks[index2].select = true;
            }
          });
        });
      });
      this.$nextTick(this.setTop);
    },
    isDef(val) {
      return val !== undefined && val !== null;
    },
    handleFocus() {
      this.toggleDropDownVisible(true);
    },
    handleBlur() {
      this.toggleDropDownVisible(false);
    },
    handelInput() {
      this.menus.forEach((el, index) => {
        if (el.qualName.indexOf(this.inputValue) == -1) {
          this.menus[index].hide = false;
        } else {
          this.menus[index].hide = true;
        }
      });
    },
    toggleDropDownVisible(visible) {
      visible = this.isDef(visible) ? visible : !this.dropDownVisible;
      if (visible !== this.dropDownVisible) {
        this.dropDownVisible = visible;
      }
    },
    setTop() {
      let height = this.$refs['cascaderTags'].clientHeight;
      if (!height) {
        height = 38;
      }
      this.top = height + "px";
    },
    initStore() {
      this.setValue(this.value);
    }
  }
};
</script>

<style scoped lang="less">

#dg__cascader {
  display: inline-block;
  position: relative;
  background-color: #FAFAFC;

  .tags {
    line-height: 28px;
    border: 1px solid #dcdfe6;
    padding-left: 15px;
    border-radius: 4px;

    .item {
      display: inline-flex;
      background-color: @themeBrightColor9;
      border-radius: 2px;
      border: 1px solid @themeBrightColor9;
      margin-bottom: 4px;
      color: @theme;
      padding-left: 10px;
      padding-right: 8px;
      line-height: 15px;
      padding-top: 3px;
      padding-bottom: 2px;

      p {
        font-size: 12px;
        max-width: 170px;
        word-break: break-word;
      }
    }

    >span {
      padding-right: 10px;
    }
  }

  .max-w-300 {
    max-width: 300px;
  }

  /deep/.dg_input {
    width: 99%;

    .el-input__inner {
      border: 0;
      padding: 0;
      height: 30px !important;
      line-height: 30px !important;
    }

    &::placeholder {
      color: #c0c4cc;
      font-size: 14px;
      /* 设置placeholder的字体大小 */
      font-family: 'Arial', sans-serif;
      /* 设置placeholder的字体 */
    }
  }

  .dg-scrollbar__view {
    padding: 8px 0;
    position: absolute;
    top: 40px;
    left: 0;
    margin: 5px 0;
    font-size: 14px;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    -webkit-box-shadow: 0 2px 12px 0 #0000003b;
    box-shadow: 0 2px 12px 0 #0000003b;
    z-index: 100;
    width: 600px;

    // display: none;
    .leve1 {
      min-width: 380px;
    }

    .leve2 {
      min-width: 200px;
    }

    ul {
      // padding: 10px 0;
      float: left;
      height: 300px;
      overflow-y: auto;
    }
  }

  .dg-cascader-node {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 7px 30px 7px 20px;
    color: #606266;
    outline: 0;
    cursor: pointer;

    &:hover {
      background: #f5f7fa;
    }

    .max-w-300 {
      line-height: 20px;
    }

    &.active {
      span,
      i {
        color: @theme;
      }
    }

    &.click {
      background-color: @themeBrightColor9;
      color: @theme;
    }
  }

  .dg-cascader-node__postfix {
    position: absolute;
    right: 10px;
  }
}
</style>
